import React from "react";
import './Body6.css';
import picture1 from './source/picture1.png'
import picture2 from './source/picture2.png'
import picture3 from './source/picture3.png'
import picture103 from './source/picture103.png'




function Body6() {

  return (
    <div className="body6">
      <div className="body6-box1">
        <div className="body6-box2">
          <div className="body6-box3">Kontakt</div>
          <div className="body6-box5"><div className="body6-box4"></div></div>
          <div className="body6-box6">
          <div className="body6-box16">
            <div className="body6-box20">
             <div className="body6-box21"><img className="body6-box21-picture1" src={picture1} alt="picture1"/></div>
             <div className="body6-box22">+420 702 898 123</div>
            </div>
            <div className="body6-box23">
             <div className="body6-box24"><img className="body6-box21-picture2" src={picture2} alt="picture2"/></div>
             <div className="body6-box25">Po-Pa 8:00 - 17:00</div>
            </div>
            <div className="body6-box26">
             <div className="body6-box27"><img className="body6-box21-picture3" src={picture3} alt="picture3"/></div>
             <div className="body6-box28">sadrokartony-zajgla@seznam.cz</div>
            </div>
            </div>
            <div className="body6-box15"><img className="body6-box21-picture103" src={picture103} alt="picture4"/></div>
          </div>
        </div> 
      </div> 
    </div>
  );
}

export default Body6;
